// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__ZoJ97","checkboxCol":"Table_checkboxCol__32kr9","emailCol":"Table_emailCol__sTSXT","actionCol":"Table_actionCol__X-3d9"};